import Utils from '../../utils/immersive_utils';

const INVALID_NUMBER_LABEL = /invalid\s*number/i;

export const formatFiniteNumberForDisplay = (n: number): string => {
  if (!Number.isFinite(n)) return '-';
  return Utils.formatNumber(n, 2);
};

export const formatBacktesterNumericCell = (
  row: Record<string, unknown>,
  key: string,
  fallbackKey?: string,
): string => {
  const value = row[key] ?? (fallbackKey ? row[fallbackKey] : undefined);

  if (value === null || value === undefined) return '-';

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed || INVALID_NUMBER_LABEL.test(trimmed)) return '-';
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? formatFiniteNumberForDisplay(parsed) : '-';
  }

  if (typeof value === 'number') return formatFiniteNumberForDisplay(value);

  return '-';
};
